"use client";

import { Container, Heading } from "@pamperedchef/design-system";

import { OfferReference } from "@/types";

import { CmsOfferCard } from "./CmsOfferCard";
import * as styles from "./OfferCardGallery.module.scss";

export interface OfferCardGalleryViewProps {
	title?: string;
	cardsContent: OfferReference[];
}

/**
 * Offer Card Gallery layout — title plus a two-column grid of offer cards.
 */
export function OfferCardGalleryView(
	props: OfferCardGalleryViewProps
): JSX.Element {
	return (
		<Container className={styles["offer-card-gallery"]}>
			{props.title && (
				<Heading
					className={styles["offer-card-gallery__title"]}
					styledAs="h1"
					tag="h2"
				>
					{props.title}
				</Heading>
			)}

			<div className={`grid ${styles["offer-card-gallery__grid"]}`}>
				{props.cardsContent?.map((card, index) => (
					<div
						key={`${card.title}-${index}`}
						className="col-xs-12 col-md-6"
					>
						<CmsOfferCard {...card} />
					</div>
				))}
			</div>
		</Container>
	);
}
